
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/help/returns-and-complaints",
      function () {
        return require("private-next-pages/help/returns-and-complaints.tsx");
      }
    ]);
  